// extracted by mini-css-extract-plugin
export default {"root":"MaskContent_root__7eX32","scroll":"MaskContent_scroll__eS5AP","disableScroll":"MaskContent_disableScroll__VJxhw"};